import { PartAlternative } from '@luminovo/api-contracts';

export const partAlternativesIdExtractor = (rowData: PartAlternative): string => {
    return rowData.off_the_shelf_part.id;
};
